import React from "react";
const steps = [
  {
    title: "Understand & Structure",
    description:
      "We begin by understanding your business, capital needs, and growth plan — then design the right capital structure before approaching any lender or investor.",
  },
  {
    title: "Identify & Approach",
    description:
      "We map the most suitable capital providers across banks, NBFCs, funds, and equity investors, and coordinate targeted outreach on your behalf.",
  },
  {
    title: "Negotiate & Syndicate",
    description:
      "We manage term sheet negotiations, due diligence, documentation, and syndication — ensuring the best terms are secured across all tranches.",
  },
  {
    title: "Close & Monitor",
    description:
      "We coordinate financial closure, escrow management, and post-disbursement reporting — your transaction management office from day one to drawdown.",
  },
];

const sectors = [
  "Real Estate & Construction",
  "Infrastructure & Energy",
  "Manufacturing & Industry",
  "Technology & Startups",
  "Healthcare & Pharma",
  "Agri & Rural Finance",
  "Logistics & Supply Chain",
  "Hospitality & Retail",
  "Renewable Energy",
  "MSME & Mid-Market",
];

export default function HowWork() {
  return (
    <div>
      <section className="bg-[#F8F9FC] py-20" id="approach">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid gap-16 lg:grid-cols-2">
            {/* Left */}

            <div>
              <p className="mb-4 text-xs font-semibold uppercase  text-[#c9a84c]">
                How We Work
              </p>

              <h2 className="max-w-lg text-4xl  text-[#182748] md:text-5xl">
                From mandate to financial closure
              </h2>

              <div className="mt-8 h-[3px] w-20 bg-[#c9a84c]" />

              <div className="mt-14 space-y-6">
                {steps.map((item, index) => (
                  <div key={index} className="relative flex gap-6">
                    {/* Timeline */}

                    <div className="relative flex flex-col items-center">
                      <span className="z-10 h-3 w-3 rounded-full bg-[#C8A54B]" />

                      {index !== steps.length - 1 && (
                        <span className="mt-2 h-[80px] w-px bg-gray-300" />
                      )}
                    </div>

                    <div className="pb-10">
                      <h3 className="mb-3 text-2xl font-medium text-[#1E2D50]">
                        {item.title}
                      </h3>

                      <p className="leading-6 text-gray-500 text-sm">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right */}

            <div className="flex items-center">
              <div className="w-full rounded-xl bg-[#0D1A30] p-10 shadow-xl">
                <p className="mb-8 text-xs uppercase tracking-[3px] text-gray-400">
                  Sectors We Serve
                </p>

                <div className="grid gap-4 sm:grid-cols-2">
                  {sectors.map((sector) => (
                    <div
                      key={sector}
                      className="rounded-md border border-[#32415D] bg-[#1A2740] px-5 py-4 text-sm text-gray-200 transition-all duration-300 hover:border-[#C8A54B] hover:bg-[#22304A] hover:text-white"
                    >
                      {sector}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
